import React from 'react'
import DodonesShow from 'app/dodones/Show'
import { useParams } from 'react-router-dom'

const entityMap = {
  dodone: DodonesShow
}

export default ({ entityName }) => {
  const { id } = useParams()
  const View = entityMap[entityName]
  const props = {};
  props[`${entityName}Id`] = id;

  return <View {...props} />;
}
